// extracted by mini-css-extract-plugin
export default {"container":"Br-z","heading":"Cr-z","text":"Dr-z","info":"Er-z","link":"Fr-z","fullMaxWidth":"Gr-z"};